// extracted by mini-css-extract-plugin
export default {"home":"home_home__aBZKd","home_box":"home_home_box__22re0","title_section":"home_title_section__XNWZ0","title":"home_title__kAQvD","btnView":"home_btnView__JyqO+"};